import { useEffect, useRef } from 'react';
import { useLocation, Location } from 'react-router-dom';

const usePreviousLocation = (): Location | null => {
  const location = useLocation();
  const prevLocationRef = useRef<Location | null>(null);

  useEffect(() => {
    prevLocationRef.current = location;
  }, [location]);

  return prevLocationRef.current;
};

export default usePreviousLocation;
